export default __webpack_public_path__ + "static/media/instaFooter.a86cf9ac.svg";